// PREZENCE — 404 Not Found
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function NotFound() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const home = user?.role === 'admin' || user?.role === 'superadmin' ? '/admin' : user?.role === 'hr' ? '/hr' : '/employee';

  return (
    <div style={{ minHeight:'100vh', background:'#05090f', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:120, fontWeight:800, background:'linear-gradient(135deg,#63dcbc,#3ba8ff)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', lineHeight:1, marginBottom:16 }}>404</div>
        <h2 style={{ fontSize:22, color:'#94a3b8', marginBottom:8 }}>Page not found</h2>
        <p style={{ fontSize:14, color:'#475569', marginBottom:28 }}>The page you're looking for doesn't exist or was moved.</p>
        <button className="btn btn-primary" onClick={() => navigate(user ? home : '/login')}>
          {user ? 'Go to Dashboard' : 'Go to Login'}
        </button>
      </div>
    </div>
  );
}
